function getWindow() {
  return globalThis.window
}

const window = getWindow()

export { window }
